export default "__VITE_ASSET__94da3279__"